import React from 'react'
import AddressSearchDialogContent from '../../routes/address/AddressSearchDialogContent'
import { PAGE_CLASSES } from '../../routes/pageClasses.constants'
import { isGE } from '../Device'
import PushNotificationPopup from '../PushNotification/PushNotificationPopup'
import AddressHeaderForm from '../address/AddressHeaderForm'
import BlueAdBanner from '../advertising/BlueAdBanner'
import { VdeBanner } from '../advertising/VdeBanner'
import Page from '../genericComponents/Page'
import Header from '../header/Header'
import ItineraryButton from '../header/ItineraryButton'
import Main from '../main/Main'
import Map from '../map/Map'
import VdeMarkers from '../map/markers/VdeMarkers'
import { isMenuCategoriesPEAvailable } from '../menu/MenuCategoriesPE'
import SearchDialog from '../search/SearchDialog'
import AddressSuggestContent from '../suggest/AddressSuggestContent'
import HomeMainContent from './HomeMainContent'
import HomeMetaManager from './seo/HomeMetaManager'

export function renderPage({ routeContext }) {
  const { store } = routeContext
  const displayMenuCategoriesPE = isMenuCategoriesPEAvailable(store.getState)

  const { SearchHomePage, withToaster, withMenuCategoriesPE } = PAGE_CLASSES

  return (
    <Page cssClasses={[SearchHomePage, withToaster, displayMenuCategoriesPE && withMenuCategoriesPE]} key="Page">
      <HomeMetaManager />
      <Map key="Map">
        <VdeMarkers />
        <VdeBanner />
        <BlueAdBanner />
      </Map>
      <Header key="Header" headerButton={<ItineraryButton />} menuCategoriesPE={displayMenuCategoriesPE}>
        <AddressHeaderForm key="AddressHeaderForm" />
      </Header>
      <SearchDialog key="SearchDialog" suggestContent={<AddressSuggestContent />}>
        <AddressSearchDialogContent />
      </SearchDialog>
      <PushNotificationPopup />
      <Main key="Main" withoutSubHeader={isGE()}>
        <HomeMainContent />
      </Main>
    </Page>
  )
}
